require('./_typed-array')('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/es6.typed.uint8-clamped-array.js
// module id = 566
// module chunks = 48 49 50 51